import { ethers } from 'ethers';
import JSZip from 'jszip';
import * as encoding from './encoding';
import * as crypt from './crypt';
import * as storage from './storage';
// export const COMPETITION_NAME = '__COMPETITION_NAME__';
const UTILS_ADDR_DEFAULT = '__REGISTRY__';
const GATEWAY = '__GATEWAY__';
const ethereum = window.ethereum;
let metamask;
let provider;
let utils;
let competition;
let competitionTransactor;
let token;
let tokenTransactor;
let faucet;
let faucetTransactor;
let conversion;
let conversionTransactor;
const conversionAddress = "__CONVERSION_ADDRESS__";
let compInterface;
let tokenInterface;
export let activeUser;
export var COMPS;
(function (COMPS) {
    COMPS[COMPS["UPDOWN"] = 0] = "UPDOWN";
    COMPS[COMPS["NEUTRAL"] = 1] = "NEUTRAL";
})(COMPS || (COMPS = {}));
async function _parseAbi(filename) {
    const response = await fetch(`/contracts/${filename}`);
    const res = (await response.json())['abi'];
    console.log(`=== Parsed ${filename}`);
    return res;
}
function _isMetaMaskInstalled() {
    return !!ethereum && ethereum.isMetaMask;
}
;
async function _setActiveUser() {
    if (_isMetaMaskInstalled()) {
        await ethereum.request({ method: 'eth_requestAccounts' });
    }
    activeUser = await metamask.getSigner().getAddress();
}
async function _cidToHash(cid) {
    const res = encoding.byteToHexString(encoding.b58ToByte(cid));
    // console.log(res);
    return `0x${res.slice(4)}`;
}
function _hashToCid(hash) {
    if (hash && hash.byteLength !== undefined) {
        hash = encoding.byteToHexString(hash);
    }
    if (hash.slice(0, 2) === '0x') {
        hash = hash.slice(2);
    }
    hash = `1220${hash}`;
    // console.log(encoding.byteToB58(encoding.hexStringToByte(hash)));
    return encoding.byteToB58(encoding.hexStringToByte(hash));
}
function _download(hash, extension) {
    const cid = _hashToCid(hash);
    const link = document.createElement('a');
    link.href = GATEWAY + cid;
    const filename = `${cid.slice(0, 9)}.${extension}`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
function _saveBlob(blob, filename) {
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
export async function retrieve(hash) {
    const cid = _hashToCid(hash);
    const request = new Request(GATEWAY + cid);
    const response = await fetch(request);
    const blob = await response.blob();
    if (response.ok) {
        return blob;
    }
    else {
        console.error('File not found.');
        return null;
    }
}
async function _getTokenAddress() {
    return utils.getTokenAddress();
}
function _appendBuffer(buffer1, buffer2) {
    const tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
    tmp.set(new Uint8Array(buffer1), 0);
    tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
    return tmp.buffer;
}
async function _submitIpfs(content) {
    const formData = new FormData();
    formData.append('file', content);
    const response = await fetch('https://api.pinata.cloud/pinning/pinFileToIPFS', {
        method: 'POST',
        body: formData,
        headers: {
            pinata_api_key: '__PINATA_API_KEY__',
            pinata_secret_api_key: '__PINATA_SECRET_API_KEY__'
        },
    });
    return response.json();
}
export async function _encryptZipUpload(predictionsFile, publicKey) {
    const predictionsData = await predictionsFile.arrayBuffer();
    const predictionsName = predictionsFile.name;
    const symmetricKey = await crypt.generateSymmetricKey();
    const iv = crypt.getIV(16);
    let encryptedPredictions = await crypt.encryptPredictions(predictionsData, symmetricKey, iv);
    const predictionsPayload = _appendBuffer(iv, encryptedPredictions);
    const originatorData = (new TextEncoder).encode(activeUser);
    const encryptedOriginator = await crypt.encryptPredictions(originatorData, symmetricKey, iv);
    const originatorPayload = _appendBuffer(iv, encryptedOriginator);
    const pubKeyData = await crypt.importRsaPublicKey(publicKey);
    const wrappedKey = await crypt.wrapSymmetricKey(symmetricKey, pubKeyData);
    const zip = new JSZip();
    zip.file(predictionsName.split('.')[0] + '.bin', predictionsPayload);
    zip.file('originator.bin', originatorPayload);
    zip.file('encrypted_symmetric_key.pem', wrappedKey);
    const content = await zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE',
        compressionOptions: { level: 3 }
    });
    console.log("submitting to IPFS");
    const response = await _submitIpfs(content);
    const cid = response['IpfsHash'];
    console.log("submitted to IPFS with CID: " + cid);
    // let responseAlert = `IPFS: File of size ${response['Size']} bytes uploaded to IPFS with CID ${cid}.<br>Downloadable <a href="https://ipfs.io/ipfs/${cid}">link</a>.`;
    // responseAlert     = `<p class="info-text alert alert-primary">${responseAlert}</p>`;
    // Store symmetric key in IndexedDB
    const rawSymmetricKey = await crypt.exportSymmetricKey(symmetricKey);
    const safeSymmetricKey = await crypt.importSymmetricKey(rawSymmetricKey);
    try {
        storage.add(cid, { key: safeSymmetricKey, iv });
    }
    catch (e) {
        // TODO
        alert(e.message);
    }
    // console.log('------------------------------')
    // console.log(await crypt.decryptPrediction(encryptedOriginator, symmetricKey, iv));
    return cid;
}
export function getCompetitionName(comp) {
    return (comp === COMPS.UPDOWN) ? '__COMPETITION_NAME__' : '__COMPETITION_NAME_2__';
}
// export async function getChainName() {
// 	const chainId = await ethereum.request({ method: 'eth_chainId' });
// 	switch (chainId) {
// 		case '1':
// 			chainName = 'MAINNET';
// 			break;
// 		case '3':
// 			chainName = 'Ropsten Test';
// 			break;
// 		case '4':
// 			chainName = 'Rinkeby Test';
// 			break;
// 		case '42':
// 			chainName = 'Kovan Test';
// 			break;
// 		default:
// 			chainName = 'Unknown Network';
// 	}
// }
// async function _getCompetitionAddress(): Promise<string> {
// 	return registry.getCompetitionAddress(COMPETITION_NAME);
// }
export function init() {
    metamask = new ethers.providers.Web3Provider(ethereum);
    provider = new ethers.providers.JsonRpcProvider('__JSON_RPC_PROVIDER__');
}
export function getCompetitionAddress(comp) {
    return competition[comp].address;
}
export function getTokenAddress() {
    return token.address;
}
export async function setup() {
    const utilsAbi = await _parseAbi('Utils.json');
    utils = new ethers.Contract(UTILS_ADDR_DEFAULT, utilsAbi, provider);
    const competitionAddress1 = '__COMPETITION_ADDRESS__';
    const competitionAddress2 = '__COMPETITION_ADDRESS_2__';
    const competitionAbi = _parseAbi('Competition.json');
    const tokenAddress = '__TOKEN_ADDRESS__';
    const tokenAbi = _parseAbi('Token.json');
    await Promise.all([competitionAbi, tokenAbi]).then(result => {
        competition = [
            new ethers.Contract(competitionAddress1, result[0], provider),
            new ethers.Contract(competitionAddress2, result[0], provider),
        ];
        token = new ethers.Contract(tokenAddress, result[1], provider);
        compInterface = new ethers.utils.Interface(result[0]);
        tokenInterface = new ethers.utils.Interface(result[1]);
    });
    const faucetAbi = await _parseAbi('Faucet.json');
    const faucetAddress = '0x20825f20bE796A0af0fCa4f7c90635d096fC1076';
    faucet = new ethers.Contract(faucetAddress, faucetAbi, provider);
    const conversionAbi = await _parseAbi('Conversion.json');
    conversion = new ethers.Contract(conversionAddress, conversionAbi, provider);
    // ethereum.on('chainChanged', getChainName);
    ethereum.on('accountsChanged', async () => {
        await _setActiveUser();
        refresh();
    });
    // ethereum.on('chainChanged', (chainId) => {
    // 	// Handle the new chain.
    // 	// Correctly handling chain changes can be complicated.
    // 	// We recommend reloading the page unless you have good reason not to.
    // 	window.location.reload();
    // });
    ethereum.on('connect', connect);
}
export function refresh() {
    competitionTransactor = [
        competition[COMPS.UPDOWN].connect(metamask.getSigner()),
        competition[COMPS.NEUTRAL].connect(metamask.getSigner()),
    ];
    tokenTransactor = token.connect(metamask.getSigner());
    RciEvents.emit('accountChanged');
    faucetTransactor = faucet.connect(metamask.getSigner());
    conversionTransactor = conversion.connect(metamask.getSigner());
}
export async function connect() {
    await _setActiveUser();
    refresh();
}
export async function addToken() {
    ethereum.request({
        method: 'wallet_watchAsset',
        params: {
            type: 'ERC20',
            options: {
                address: '__TOKEN_ADDRESS__',
                symbol: '__TOKEN_SYMBOL__',
                decimals: 6,
                image: 'https://yiedl-assets.web.app/yiedlai.png'
            }
        }
    });
}
export async function addUsdc() {
    ethereum.request({
        method: 'wallet_watchAsset',
        params: {
            type: 'ERC20',
            options: {
                address: '__USDC_ADDRESS__',
                symbol: 'USDC',
                decimals: 6,
                image: 'https://www.centre.io/hubfs/usdc-icon-86074d9d49.png'
            }
        }
    });
}
export async function drip() {
    const tx = await faucetTransactor.drip();
    const promise = provider.waitForTransaction(tx['hash'], 1, 3 * 60 * 1000);
    return [tx, promise];
}
export async function isConnected() {
    const chainId = await ethereum.request({ method: 'eth_chainId' });
    return chainId === '0x89';
    // return chainId === '0x13881';
}
export async function switchNetwork() {
    let chainId = await ethereum.request({ method: 'eth_chainId' });
    if (chainId === 137) {
        // if (chainId === 80001) {
        return true;
    }
    try {
        await ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x89' }],
            // params: [{ chainId: '0x13881' }],
        });
        return true;
    }
    catch (error) {
        // This error code indicates that the chain has not been added to MetaMask.
        // TODO: on the Metamask mobile browser, getting error -32603, check why
        // if (error.code === 4902 || error.code === -32603) {
        try {
            await ethereum.request({
                method: 'wallet_addEthereumChain',
                params: [{
                        chainName: 'Polygon',
                        rpcUrls: ['https://polygon-rpc.com'],
                        chainId: '0x89',
                        nativeCurrency: {
                            name: 'POL',
                            symbol: 'POL',
                            decimals: 18
                        },
                        blockExplorerUrls: ['https://polygonscan.com'],
                        iconUrls: ['https://polygonscan.com/images/logo-white.svg']
                    }],
            });
            // await ethereum.request({
            // 	method: 'wallet_addEthereumChain',
            // 	params: [{
            // 		chainName: 'Polygon',
            // 		rpcUrls: ['https://rpc.ankr.com/polygon_mumbai'],
            // 		chainId: '0x13881',
            // 		nativeCurrency: {
            // 			name: 'MATIC',
            // 			symbol: 'MATIC',
            // 			decimals: 18
            // 		},
            // 		blockExplorerUrls: ['https://mumbai.polygonscan.com'],
            // 		iconUrls: ['https://polygonscan.com/images/logo-white.svg']
            // 	}],
            // });
            return true;
        }
        catch (addError) {
            console.error(addError);
            return false;
        }
    }
}
// Deadlines
export async function getSubmissionDeadline(comp, challengeNumber) {
    return (await competition[comp].getDeadlines(challengeNumber, 0)).toNumber();
}
export async function getResultDeadline(comp, challengeNumber) {
    return (await competition[comp].getDeadlines(challengeNumber, 1)).toNumber();
}
export async function getNextChallengeDeadline(comp, challengeNumber) {
    return (await competition[comp].getDeadlines(challengeNumber, 2)).toNumber();
}
// export async function downloadCompetitionKey(phaseIndex: number) {
// 	const keyHash = await competition.getKeyHash(phaseIndex);
// 	if (parseInt(keyHash, 16) === 0) {
// 		// TODO: throw
// 		console.error(`No dataset found for phase ${phaseIndex}.`);
// 	}
// 	// Download from IPFS. Browser will ask for a download confirmation.
// 	return (await retrieve(keyHash)).text();
// }
export async function getLatestChallengeNumber(comp) {
    return competition[comp].getLatestChallengeNumber();
}
// The following are functions to read general information from the smart contract.
export async function getCompetitionPool(comp) {
    return ethers.utils.formatUnits(await competition[comp].getCompetitionPool(), 6);
}
export async function getPhase(comp, phaseIndex) {
    return competition[comp].getPhase(phaseIndex);
}
export async function downloadPhaseDataset(comp, phaseIndex) {
    const datasetHash = await competition[comp].getDatasetHash(phaseIndex);
    if (parseInt(datasetHash, 16) === 0) {
        console.error(`No dataset found for phase ${phaseIndex}.`);
    }
    // Download from IPFS. Browser will ask for a download confirmation.
    _download(datasetHash, 'zip');
}
export async function getInformation(comp, challengeNumber, participant = activeUser, itemNumber = 0) {
    return await competition[comp].getInformation(challengeNumber, participant, itemNumber);
}
export async function getCurrentTotalStaked(comp) {
    return ethers.utils.formatUnits(await competition[comp].getCurrentTotalStaked(), 6);
}
export async function getStake(comp) {
    // const caller = await provider.getSigner().getAddress();
    const caller = activeUser;
    return ethers.utils.formatUnits(await competition[comp].getStake(caller), 6);
}
export async function getStakeThreshold(comp) {
    return ethers.utils.formatUnits(await competition[comp].getStakeThreshold(), 6);
}
export async function getAllocation() {
    const caller = activeUser;
    const alloc = ethers.utils.formatUnits(await conversion.allocation(caller), 6);
    return alloc;
}
export async function getAllowance() {
    const caller = activeUser;
    const allowance = ethers.utils.formatUnits(await token.allowance(caller, conversion.address), 6);
    return allowance;
}
export async function getRate() {
    const rate = ethers.utils.formatUnits(await conversion.rate(), 6);
    return rate;
}
// export async function increaseStake(amount: ethers.BigNumber) {
// 	const tx = await token.increaseStake(competition.address, amount);
// 	const promise = provider.waitForTransaction(tx['hash']);
// 	return [tx, promise];
// }
// export async function decreaseStake(amount: ethers.BigNumber) {
// 	const tx = await token.decreaseStake(competition.address, amount);
// 	const promise = provider.waitForTransaction(tx['hash']);
// 	return [tx, promise];
// }
export async function setStake(comp, amount) {
    const tx = await competitionTransactor[comp].setStake(amount, activeUser);
    // const promise = provider.waitForTransaction(tx['hash'], 1, 10);
    // const promise = provider.waitForTransaction(tx['hash']);
    const promise = provider.waitForTransaction(tx['hash'], 1, 3 * 60 * 1000);
    return [tx, promise];
}
export async function getSubmissionHash(comp, challengeNumber) {
    // const caller = await provider.getSigner().getAddress();
    const caller = activeUser;
    // console.log(comp, challengeNumber, caller)
    const hash = await competition[comp].getSubmission(challengeNumber, caller);
    return parseInt(hash, 16) ? hash : null;
}
// 0000000000000000000000000000000000000000000000000000000000000000
// 0x
// d9caa3d2
// 0000000000000000000000000000000000000000000000000000000000000000
// 0x
// 224961bb
// 0000000000000000000000000000000000000000000000000000000000000000
// 000000000000000000000000eBA5BA85f72e40A9f2b8782C2bd51eC31a5564dA
export async function stakeAndSubmit(comp, amount, predictionsFile, pubKey) {
    // Encrypt, zip and upload to IPFS.
    if (amount.eq(ethers.BigNumber.from(0))) {
        console.log("here");
        const myHash = "0x0000000000000000000000000000000000000000000000000000000000000000";
        const challengeNumber = await getLatestChallengeNumber(comp);
        const submissionHash = await getSubmissionHash(comp, challengeNumber);
        if (submissionHash) {
            const tx = await competitionTransactor[comp].submit(myHash);
            const promise = provider.waitForTransaction(tx['hash'], 1, 3 * 60 * 1000);
            return [tx, promise];
        }
        return setStake(comp, ethers.BigNumber.from(0));
    }
    else {
        if (predictionsFile) {
            const myCid = await _encryptZipUpload(predictionsFile, pubKey);
            const myHash = _cidToHash(myCid);
            const tx = await competitionTransactor[comp].stakeAndSubmit(amount, myHash);
            const promise = provider.waitForTransaction(tx['hash'], 1, 3 * 60 * 1000);
            return [tx, promise];
        }
        else {
            return setStake(comp, amount);
        }
    }
}
export async function convert(amountYiedl) {
    const tx = await conversionTransactor.convert(amountYiedl);
    const promise = provider.waitForTransaction(tx['hash'], 2, 3 * 60 * 1000);
    return [tx, promise];
}
export async function approve() {
    const allowance = await token.allowance(activeUser, conversion.address);
    const tx = await tokenTransactor.increaseAllowance(conversion.address, ethers.constants.MaxUint256.sub(allowance));
    // const tx = await tokenTransactor.approve(conversion.address, ethers.constants.MaxUint256);
    const promise = provider.waitForTransaction(tx['hash'], 2, 3 * 60 * 1000);
    return [tx, promise];
}
export async function approveCompetition(comp) {
    // const allowance = await token.allowance(activeUser, competition[comp].address);
    // console.log(competition[comp].address, ethers.constants.MaxUint256.sub(allowance), allowance, activeUser);
    // const tx = await tokenTransactor.increaseAllowance(competition[comp].address, ethers.constants.MaxUint256.sub(allowance));
    console.log('====', competition[comp].address, ethers.constants.MaxUint256, activeUser, tokenTransactor);
    const tx = await tokenTransactor.approve(competition[comp].address, ethers.constants.MaxUint256);
    console.log('====', tx);
    const promise = provider.waitForTransaction(tx['hash'], 2, 3 * 60 * 1000);
    return [tx, promise];
}
// // TODO return type
// export async function makeSubmission(comp: COMPS, predictionsFile: File, pubKey: string) {
// 	// Encrypt, zip and upload to IPFS.
// 	const myCid = await _encryptZipUpload(predictionsFile, pubKey);
//
// 	// Submit hash to blockchain.
// 	const txObj = await competitionTransactor[comp].submitNewPredictions(_cidToHash(myCid));
// 	// const promise = provider.waitForTransaction(txObj['hash']);
// 	const promise = provider.waitForTransaction(txObj['hash'], 1, 3 * 60 * 1000);
//
// 	return [txObj, promise];
// }
// // TODO return type
// export async function redoSubmission(comp: COMPS, predictionsFile: File, pubKey: string) {
// 	const challengeNumber = await getLatestChallengeNumber(comp);
// 	const submissionHash = await getSubmissionHash(comp, challengeNumber);
//
// 	// Encrypt, zip and upload to IPFS.
// 	const myCid = await _encryptZipUpload(predictionsFile, pubKey);
//
// 	// Submit hash to blockchain.
// 	const txObj = await competitionTransactor[comp].updateSubmission(submissionHash, _cidToHash(myCid));
// 	// console.log(txObj);
// 	const promise = provider.waitForTransaction(txObj['hash'], 1, 3 * 60 * 1000);
// 	// const promise = provider.waitForTransaction(txObj['hash']);
//
// 	return [txObj, promise];
// }
export async function downloadOwnSubmission(comp, challengeNumber) {
    try {
        const submissionHash = await getSubmissionHash(comp, challengeNumber);
        // if (parseInt(submissionHash, 16) === 0) {
        if (submissionHash === null) {
            return null;
        }
        // Download from IPFS. Browser will ask for a download confirmation.
        // return _download(submissionHash, 'zip');
        const blob = await retrieve(submissionHash);
        const dbObj = await storage.get(_hashToCid(submissionHash));
        if (!dbObj) {
            // TODO download without decrypting
            return;
        }
        const { key, iv } = dbObj;
        const zip = new JSZip();
        zip.loadAsync(await blob.arrayBuffer(), {
            checkCRC32: true
        }).then(zip => {
            Object.keys(zip.files).forEach(filename => {
                if (filename.endsWith('.bin') && filename !== 'originator.bin') {
                    // It's the prediction file
                    zip.files[filename].async('blob').then(async (fileData) => {
                        const encryptedPrediction = (await fileData.arrayBuffer()).slice(iv.length);
                        const decrypted = await crypt.decryptPrediction(encryptedPrediction, key, iv);
                        // console.log((new TextDecoder('utf-8')).decode(decrypted));
                        _saveBlob(new Blob([decrypted]), filename.substring(0, filename.length - 4) + '.csv');
                    });
                }
            });
        }, e => {
            alert('Zip file is corrupted');
            // TODO
        });
        // console.log(await crypt.decryptPrediction(await blob.arrayBuffer(), key, iv));
    }
    catch (e) {
        console.error(e);
    }
}
export async function getResultsHash(comp, phaseIndex) {
    const resultsHash = await competition[comp].getResultsHash(phaseIndex);
    return (parseInt(resultsHash, 16) === 0)
        ? 'No results posted for this phase.'
        : _hashToCid(resultsHash);
}
// export async function downloadPhaseResults(phaseIndex: number) {
// 	const resultsHash = await competition.getResultsHash(phaseIndex);
// 	if (parseInt(resultsHash,16)==0){
// 		console.error("No results found for phase " + phaseIndex + ".");
// 		return null;
// 	}
// 	// Download from IPFS. Browser will ask for a download confirmation.
// 	await retrieve(resultsHash.text());
// }
export async function obtainMyHistoricalScores(comp) {
    const [phases, results] = await _obtainOverallIpfs(comp);
    if (phases === null) {
        // console.error("No results found for " + await provider.getSigner().getAddress() + ".");
        console.error('No results found for ' + activeUser + '.');
        return [null, null];
    }
    return [phases, results];
}
export async function _obtainOverallIpfs(comp) {
    const challengeNumber = await getLatestChallengeNumber(comp);
    const resultsHash = await competition[comp].getResultsHash(challengeNumber);
    if (parseInt(resultsHash, 16) === 0) {
        console.error('No results found for phase ' + challengeNumber + '.');
        return [null, null];
    }
    const cid = _hashToCid(resultsHash);
    const url = GATEWAY + cid;
    const response = await fetch(url);
    const reader = response.body.getReader();
    let data = await reader.read();
    const decoder = new TextDecoder();
    let rows = decoder.decode(data.value).split('\n');
    // const activeUser = await provider.getSigner().getAddress();
    for (let i = 0; i < rows.length; i++) {
        const cols = rows[i].split(',');
        if (cols[1] === activeUser) {
            return await _obtainFromIndividualIpfs(cols[2]);
        }
    }
    while (!data.done) {
        data = await reader.read();
        rows = decoder.decode(data.value).split('\n');
        for (let i = 0; i < rows.length; i++) {
            let cols = rows[i].split(',');
            if (cols[1] === activeUser) {
                return await _obtainFromIndividualIpfs(cols[2]);
            }
        }
    }
    return [null, null];
}
export async function _obtainFromIndividualIpfs(cid) {
    const url = GATEWAY + cid;
    const response = await fetch(url);
    const reader = response.body.getReader();
    let data = await reader.read();
    const decoder = new TextDecoder();
    let rows = decoder.decode(data.value).split('\n');
    let cols;
    const phases = [];
    const scores = [];
    // skip first row of labels.
    for (let i = 1; i < rows.length; i++) {
        cols = rows[i].split(',');
        if (cols[1] !== null) {
            phases.push(cols[1]);
            scores.push(cols[2]);
        }
    }
    while (!data.done) {
        data = await reader.read();
        rows = decoder.decode(data.value).split('\n');
        for (let i = 0; i < rows.length; i++) {
            cols = rows[i].split(',');
            if (cols[1] !== null) {
                phases.push(cols[1]);
                scores.push(cols[2]);
            }
        }
    }
    if (!phases.length) {
        return [null, null];
    }
    return [phases, scores];
}
export class RciEvents {
    static addListener(evt, listener) {
        if (!RciEvents.listeners[evt]) {
            console.log('adding event for ' + evt);
            RciEvents.listeners[evt] = [];
        }
        // TODO: check if the event is already there
        RciEvents.listeners[evt].push(listener);
    }
    // TODO add removeListener
    static emit(evt) {
        const listeners = RciEvents.listeners;
        if (listeners && listeners[evt]) {
            listeners[evt].forEach(listener => listener());
        }
    }
}
RciEvents.listeners = {};
// REWARDS AND SCORES
// function formatEther(fn: (n: number, p: string) => Promise<string>) {
// 	return (async (challengeNumber: number, participant: string = activeUser) => {
// 		const result = await fn(challengeNumber, participant);
// 		return ethers.utils.formatEther(result);
// 	});
// }
// function formatEtherArray(methodName: string) {
// 	return (async (challengeNumberStart: number, challengeNumberEnd: number, participant: string = activeUser) => {
// 		const result = await competition[methodName](challengeNumberStart, challengeNumberEnd, participant);
// 		return result.map(ethers.utils.formatEther);
// 	});
// }
// export const getChallengeScores = formatEther(competition.getChallengeScores)
// export const getChallengeScoresList    = formatEtherArray('getChallengeScoresList');
// export const getCompetitionScoresList  = formatEtherArray('getTournamentScoresList');
// export const getStakingRewardsList     = formatEtherArray('getStakingRewardsList');
// export const getChallengeRewardsList   = formatEtherArray('getChallengeRewardsList');
// export const getCompetitionRewardsList = formatEtherArray('getTournamentRewardsList');
// export const getOverallRewardsList     = formatEtherArray('getOverallRewardsList');
export async function batchCall(contractList, fnList, argList, returnTypeList) {
    const sendIfs = {
        [competition[COMPS.UPDOWN].address]: compInterface,
        [competition[COMPS.NEUTRAL].address]: compInterface,
        [token.address]: tokenInterface,
    };
    const returnFns = {
        uint: (x) => parseInt(x, 16),
        float: (x) => +ethers.utils.formatUnits(x, 6),
        hash: (x) => parseInt(x, 16) ? x : null,
        address: (x) => `0x${x.slice(-40)}`,
        bool: (x) => parseInt(x, 16),
        raw: (x) => x
    };
    const sendList = contractList.map((addr, i) => sendIfs[addr] && sendIfs[addr].encodeFunctionData(fnList[i], argList[i]) || null);
    const returnBytes = await utils.batchCall(contractList, sendList);
    // returnTypeList.forEach((type, i) => {
    // 	console.log(i, type, returnFns[type] && returnFns[type](returnBytes[i]))
    // })
    return returnTypeList.map((type, i) => returnFns[type] && returnFns[type](returnBytes[i]));
}
export async function getRewardsAndScoresData(comp, challengeNumberStart, challengeNumberEnd, participant = activeUser) {
    const fnNameArr = ['getStakedAmountForChallenge', 'getTournamentScores', 'getStakingRewards', 'getChallengeRewards', 'getTournamentRewards', 'getBurnedAmount'];
    const period = Math.max(challengeNumberEnd - challengeNumberStart + 1, 0);
    const nFunctions = fnNameArr.length;
    let challenges = [...Array(period).keys()].map(value => value + challengeNumberStart);
    challenges = [].concat(...Array(nFunctions).fill(challenges));
    const fnList = fnNameArr.reduce((prev, fnName) => [...prev, ...Array(period).fill(fnName)], []);
    const sendList = fnList.map((fn, i) => compInterface.encodeFunctionData(fn, [challenges[i], participant]));
    const addresses = Array(period * nFunctions).fill(competition[comp].address);
    const returnBytes = await utils.batchCall(addresses, sendList);
    // console.log(period, nFunctions, competition)
    //
    // // console.log(comp, competition[comp], competition[comp].address)
    // console.log("SENDLIST", sendList)
    //
    // console.log("SCORES", returnBytes)
    return returnBytes.map(x => ethers.utils.formatUnits(x, 6));
}
export async function getSubmissionCountList(comp, challengeNumberStart, challengeNumberEnd) {
    const period = challengeNumberEnd + 1 - challengeNumberStart;
    const challenges = [...Array(period).keys()].map(value => value + challengeNumberStart);
    const addresses = Array(period).fill(getCompetitionAddress(comp));
    const fnList = Array(period).fill('getSubmissionCounter');
    const sendList = fnList.map((fn, i) => compInterface.encodeFunctionData(fn, [challenges[i]]));
    const returnBytes = await utils.batchCall(addresses, sendList);
    return returnBytes.map(x => parseInt(x, 16));
}
export async function getSubmissionCounter(comp, phaseIndex) {
    return competition[comp].getSubmissionCounter(phaseIndex);
}
export async function getSubmitters(comp, phaseIndex) {
    return competition[comp].getSubmitters(phaseIndex, 0, await competition[comp].getSubmissionCounter(phaseIndex));
}
function _parseAddress(value, len) {
    for (let i = 0; i < len; i++) {
        value[i] = '0x' + value[i].substring(24, 64);
    }
    return value;
}
function _parseSubmitters(rawBytes) {
    const arrayLen = parseInt(rawBytes.substring(66, 130), 16);
    let submitters = rawBytes.substring(130, rawBytes.length);
    submitters = submitters.match(/.{64}/g);
    return _parseAddress(submitters, arrayLen);
}
async function _getSubmittersList(comp, challengeNumberStart, challengeNumberEnd) {
    const countList = await getSubmissionCountList(comp, challengeNumberStart, challengeNumberEnd);
    const period = challengeNumberEnd + 1 - challengeNumberStart;
    let challenges = Array.from(new Array(period).keys()).map(value => { return value + challengeNumberStart; });
    const addresses = Array(period).fill(competition[comp].address);
    const fnList = Array(period).fill('getSubmitters');
    const sendList = fnList.map((fn, i) => { return compInterface.encodeFunctionData(fn, [challenges[i], 0, countList[i]]); });
    const returnBytes = await utils.batchCall(addresses, sendList);
    const submittersPerChallenge = returnBytes.map(_parseSubmitters).map(x => x || []);
    const submittersSet = new Set();
    submittersPerChallenge.forEach(s => s.forEach(item => submittersSet.add(item)));
    return Array.from(submittersSet.values());
}
export async function getStakingRewardsHistory(comp, challengeNumberStart, challengeNumberEnd) {
    const fnNameArr = ['getTournamentScores', 'getStakingRewards', 'getChallengeRewards', 'getTournamentRewards', 'getOverallRewards'];
    const nFunctions = fnNameArr.length;
    const submitters_ = await _getSubmittersList(comp, challengeNumberStart, challengeNumberEnd);
    const nSubmitters = submitters_.length;
    const submitters = submitters_.reduce((prev, fnName) => [...prev, ...Array(nFunctions).fill(fnName)], []);
    const fnList = [].concat(...Array(nSubmitters).fill(fnNameArr));
    const sendList = fnList.map((fn, i) => compInterface.encodeFunctionData(fn, [challengeNumberEnd, submitters[i]]));
    const addresses = Array(nSubmitters * nFunctions).fill(competition[comp].address);
    const returnBytes = await utils.batchCall(addresses, sendList);
    const returnNumbers = returnBytes.map(x => +ethers.utils.formatUnits(x, 6));
    return submitters_.map((s, i) => ({
        wallet: s,
        competitionScore: returnNumbers[i * nFunctions],
        stakingReward: returnNumbers[i * nFunctions + 1],
        challengeReward: returnNumbers[i * nFunctions + 2],
        competitionReward: returnNumbers[i * nFunctions + 3],
        overallReward: returnNumbers[i * nFunctions + 4]
    })).sort((a, b) => {
        return b.competitionScore - a.competitionScore;
    });
}
export async function getLeaderboardCount(comp) {
    return (await competition[comp].getInformation(0, '0x' + '0'.repeat(40), 0)).toNumber();
}
function fromTwosComplement(byteString, numBytes = 4) {
    const intVal = parseInt(byteString, 16);
    const numBits = numBytes * 8;
    const sigVal = 2 ** (numBits - 1);
    let res;
    if (intVal >= sigVal) {
        res = (intVal - sigVal) - sigVal;
    }
    else {
        res = intVal;
    }
    return res;
}
export async function getLeaderboardEntries(comp, numParticipants) {
    const addresses = Array(numParticipants * 2).fill(competition[comp].address);
    const fnList = Array(numParticipants * 2).fill('getInformation');
    const ranks = Array.from(new Array(numParticipants), (_, i) => '0x'
        + '0'.repeat(40 - (i + 1).toString().length)
        + (i + 1).toString());
    const sendList0 = fnList.slice(0, numParticipants)
        .map((fn, i) => compInterface.encodeFunctionData(fn, [0, ranks[i], 0]));
    const sendList = [...sendList0];
    const returnBytes = await utils.batchCall(addresses, sendList);
    let addrFront = Array(numParticipants).fill(0);
    let addrBack = Array(numParticipants).fill(0);
    let challenges = Array(numParticipants).fill(0);
    let avgStake = Array(numParticipants).fill(0);
    let totalEarned = Array(numParticipants).fill(0);
    let avgGain = Array(numParticipants).fill(0);
    let stdDevGain = Array(numParticipants).fill(0);
    addrFront = addrFront.map((val, i) => returnBytes[i].slice(2, 16));
    addrBack = addrBack.map((val, i) => returnBytes[i].slice(16, 30));
    challenges = challenges.map((val, i) => ethers.utils.formatUnits("0x" + returnBytes[i].slice(30, 34), 0));
    avgStake = avgStake.map((val, i) => ethers.utils.formatUnits("0x" + returnBytes[i].slice(34, 42), 2));
    totalEarned = totalEarned.map((val, i) => ethers.utils.formatUnits(fromTwosComplement("0x" + returnBytes[i].slice(42, 50)), 2));
    avgGain = avgGain.map((val, i) => ethers.utils.formatUnits(fromTwosComplement("0x" + returnBytes[i].slice(50, 58)), 4));
    stdDevGain = stdDevGain.map((val, i) => ethers.utils.formatUnits("0x" + returnBytes[i].slice(58, 66), 2));
    // return [participants, scores, compRewardsTotal, overallRewardsTotal];
    return addrFront.map((p, i) => ({
        addrFront: p,
        addrBack: addrBack[i],
        challenges: +challenges[i],
        avgStake: +avgStake[i],
        totalEarned: +totalEarned[i],
        avgGain: +avgGain[i],
        stdDevGain: +stdDevGain[i]
    }));
}
